var e = {
	settings: {
		heading: "Settings",
		title: "Account Settings"
	},
	tab: {
		title: "Account",
		signInPrompt: "Sign in to manage your trips, messages, and saved places.",
		logInOrSignUp: "Log in or sign up",
		becomeHost: "Become a host",
		switchToHosting: "Switch to hosting",
		switchToHostingError: "Couldn't switch to hosting. Please try again.",
		profile: "Profile",
		favorites: "Favorites",
		help: "Help",
		logOut: "Log out"
	},
	sections: {
		gettingStarted: {
			label: "Getting Started",
			description: "Your setup checklist — pick up where you left off."
		},
		details: {
			label: "Account Details",
			description: "Your name, photo, and contact information."
		},
		security: {
			label: "Security",
			description: "Password, two-factor authentication, and active sessions."
		},
		notifications: {
			label: "Notifications",
			pageTitle: "Notification Settings",
			description: "Choose how and when we reach out to you."
		},
		privacy: {
			label: "Privacy",
			pageTitle: "Privacy Settings",
			description: "Control your data, visibility, and account."
		},
		language: {
			label: "Language & Currency",
			description: "Set your language, region, and preferred currency."
		},
		paymentMethods: {
			label: "Payment Methods",
			description: "Manage saved cards and billing details."
		},
		identityVerification: {
			label: "Identity Verification",
			description: "Verify your identity with your details and documents."
		},
		login: {
			label: "Login & Connected Accounts",
			description: "Sign-in methods and linked accounts."
		},
		help: {
			label: "Help & Support",
			description: "Get help and read our policies."
		},
		coupons: {
			label: "My Coupons",
			description: "Discount codes and rewards on your account."
		},
		creatorPartner: {
			label: "Creator Partner",
			description: "Apply to share Maat with your audience."
		}
	},
	details: {
		photo: {
			title: "Profile photo",
			description: "A photo helps personalise your account.",
			fallbackName: "You",
			upload: "Upload new photo",
			uploading: "Uploading…",
			hint: "JPG, PNG or WebP — up to 5 MB.",
			updated: "Photo updated",
			uploadFailed: "Failed to upload photo",
			removed: "Photo removed",
			removeFailed: "Failed to remove photo"
		},
		contact: {
			title: "Contact",
			description: "Used for sign-in and important account notices.",
			emailLabel: "Email",
			emailPlaceholder: "you@example.com",
			verified: "Verified",
			changeEmail: "Change email",
			phoneLabel: "Phone number",
			phonePlaceholder: "Add a phone number",
			addVerify: "Add & verify"
		},
		personal: {
			title: "Personal information",
			description: "This information appears on your profile.",
			firstNameLabel: "First name",
			firstNamePlaceholder: "First name",
			firstNameRequired: "First name is required",
			lastNameLabel: "Last name",
			lastNamePlaceholder: "Last name",
			lastNameRequired: "Last name is required",
			aboutLabel: "About",
			aboutPlaceholder: "Tell guests a little about yourself",
			save: "Save changes",
			updated: "Profile updated",
			updateFailed: "Failed to update profile"
		}
	},
	security: {
		password: {
			changeTitle: "Change password",
			setTitle: "Set a password",
			description: "Use a strong password you don't use elsewhere."
		},
		twoFactor: {
			title: "Two-factor authentication",
			description: "Add an extra layer of security at sign-in.",
			authenticatorApp: "Authenticator app",
			on: "On",
			off: "Off",
			disable: "Disable",
			enable: "Enable"
		},
		sessions: {
			title: "Recent logins",
			description: "The latest sign-ins to your account.",
			empty: "No recent logins yet.",
			unknownDevice: "Unknown device",
			unknownIp: "Unknown IP",
			mfa: "MFA",
			trusted: "Trusted",
			method: {
				password: "Password",
				otp: "Email code",
				phone_otp: "Phone code",
				passkey: "Passkey",
				password_reset: "Password reset"
			}
		}
	},
	notifications: {
		channels: {
			title: "Channels",
			description: "Pick where you want to receive notifications.",
			in_app: { description: "Show inside the app notification centre." },
			email: { description: "Send to your account email address." },
			sms: { description: "Text important updates to your phone." },
			push: { description: "Push notifications on your devices." }
		},
		categories: {
			title: "What you hear about",
			description: "Mute the notifications you don't care about.",
			locked: "Always on — security alerts can't be muted."
		},
		quietHours: {
			title: "Quiet hours",
			description: "Pause non-urgent notifications during these hours.",
			from: "From",
			to: "To",
			timezoneLabel: "Timezone",
			timezonePlaceholder: "Select timezone",
			unsubscribeLabel: "Unsubscribe from all marketing emails",
			unsubscribeAll: "Unsubscribe from all",
			saved: "Quiet hours saved",
			saveFailed: "Failed to save quiet hours"
		},
		form: {
			loading: "Loading…",
			saveFailed: "Failed to save notification settings",
			saving: "Saving…",
			saved: "All changes saved",
			autoSave: "Changes save automatically"
		}
	},
	privacy: {
		visibility: {
			title: "Visibility",
			description: "Decide what others can see about you.",
			publicProfile: "Public profile",
			publicProfileDescription: "Let other members view your profile.",
			searchEngines: "Show in search engines",
			searchEnginesDescription: "Allow your public profile to be indexed."
		},
		data: {
			title: "Data & personalisation",
			description: "How we use your data to improve your experience.",
			recommendations: "Personalised recommendations",
			recommendationsDescription: "Use my activity to tailor suggestions.",
			analytics: "Share usage analytics",
			analyticsDescription: "Help us improve with anonymous usage data.",
			download: "Download my data"
		},
		delete: {
			title: "Delete account",
			description: "Deactivate your account now; it is permanently erased after a 30-day grace period. Signing back in during that window restores it.",
			action: "Delete my account",
			flow: {
				title: "Delete my account",
				blockers: {
					checkingDescription: "Checking whether your account can be deleted…",
					clearDescription: "All checks passed — your account can be deleted.",
					blockedDescription: "A few things need to be resolved first.",
					heading: "You can't delete your account yet"
				},
				consequences: {
					description: "Here's what deleting your account means.",
					graceTitle: "Deactivated today, erased in 30 days",
					graceBody: "Your account is deactivated immediately and permanently erased after a 30-day grace period. Change your mind? Just sign back in before then and everything is restored.",
					keptTitle: "What we keep",
					keptRecords: "Booking and payment records we're legally required to retain, anonymized",
					keptContent: "Reviews and messages you've written stay, with your authorship anonymized",
					deletedTitle: "What is deleted",
					deletedProfile: "Your profile, photo, and personal details",
					deletedPayment: "Saved cards and payout details",
					deletedActivity: "Favorites, preferences, and notification settings"
				},
				reauth: {
					description: "Confirm it's you to continue.",
					passwordLabel: "Your password",
					totpLabel: "Authentication code",
					totpHint: "Enter the 6-digit code from your authenticator app — or one of your recovery codes",
					otpIntro: "We'll email a 6-digit code to {{email}} to confirm it's you.",
					sendCode: "Email me a code",
					sending: "Sending…",
					otpLabel: "Verification code",
					otpHint: "Enter the 6-digit code we emailed to {{email}}",
					resend: "Resend code",
					invalid: "That didn't match — try again.",
					submit: "Delete my account",
					submitting: "Deleting…",
					errorTitle: "Couldn't delete your account",
					sendFailedTitle: "Couldn't send the code",
					codeTooShort: "Enter your 6-digit code or a recovery code",
					oauthIntro: "Confirm with the account you use to sign in.",
					oauthGoogle: "Confirm with Google",
					oauthApple: "Confirm with Apple",
					phoneIntro: "We send a 6-digit code to {{phone}} to confirm it is you.",
					phoneSendCode: "Send code",
					phoneLabel: "Verification code",
					phoneHint: "Sent to {{phone}}"
				},
				done: {
					description: "You're signed out on every device.",
					heading: "Your account is scheduled for deletion",
					body: "Your account is deactivated and will be permanently deleted on {{date}}. If you change your mind, just sign back in before then to restore it.",
					finish: "Done"
				}
			}
		}
	},
	language: {
		region: {
			title: "Language & region",
			description: "Used across the app and in emails we send you.",
			languageLabel: "Language",
			languagePlaceholder: "English",
			regionLabel: "Region",
			regionPlaceholder: "Select a region",
			timezoneLabel: "Timezone",
			timezonePlaceholder: "Device timezone",
			formatLabel: "Date & number format",
			formatPlaceholder: "Automatic",
			save: "Save language",
			updated: "Language updated",
			updateFailed: "Failed to update language"
		},
		currency: {
			title: "Currency",
			description: "Prices are shown in your preferred currency.",
			preferredLabel: "Preferred currency",
			preferredPlaceholder: "USD",
			save: "Save preferences",
			updated: "Currency updated",
			updateFailed: "Failed to update currency"
		}
	},
	paymentMethods: {
		savedCards: {
			title: "Saved cards",
			description: "Cards you can use at checkout.",
			empty: "No payment methods yet — add a card to speed up checkout.",
			add: "Add payment method",
			adding: "Opening secure form…",
			added: "Card added",
			addError: "Couldn't add your card. Please try again.",
			sdkUnavailable: "Adding a card isn't available in this build.",
			defaultBadge: "Default",
			delete: "Remove",
			deleteCancel: "Cancel",
			deleteConfirmTitle: "Remove card?",
			deleteConfirmMessage: "{{card}} will be removed from your account.",
			deleted: "Card removed",
			deleteError: "Couldn't remove the card. Please try again."
		},
		billing: {
			title: "Billing address",
			description: "Appears on your receipts and used at checkout.",
			firstNameLabel: "First name",
			firstNamePlaceholder: "First name",
			lastNameLabel: "Last name",
			lastNamePlaceholder: "Last name",
			emailLabel: "Email",
			emailPlaceholder: "Email",
			phoneLabel: "Phone",
			phonePlaceholder: "Phone number",
			countryLabel: "Country",
			countryPlaceholder: "Country",
			streetLabel: "Address line",
			streetPlaceholder: "Street address",
			cityLabel: "City",
			cityPlaceholder: "City",
			stateLabel: "State / Province",
			statePlaceholder: "State",
			postalCodeLabel: "Postal code",
			postalCodePlaceholder: "Postal code",
			save: "Save billing details",
			saved: "Billing details saved",
			saveFailed: "Failed to save billing details"
		}
	},
	login: {
		signInMethod: {
			title: "Sign-in method",
			description: "How you sign in to your account.",
			passwordTitle: "Password",
			noPasswordTitle: "No password configured",
			passwordDescription: "Sign in with your email and password.",
			oauthDescription: "This account was set up with {{providers}}. Set a password to also sign in with your email.",
			otpDescription: "You sign in with a one-time code sent to your email. Set a password for faster sign-in.",
			set: "Set",
			changePassword: "Change password",
			setPassword: "Set a password",
			phoneOnlyTitle: "Phone number",
			phoneOnlyDescription: "You sign in with a one-time code sent to your phone. Set a password to sign in with one."
		},
		connectedAccounts: {
			title: "Connected accounts",
			description: "Link accounts to sign in faster.",
			connected: "Account connected",
			connectError: "Could not connect",
			disconnected: "Account disconnected",
			disconnectError: "Could not disconnect",
			removing: "Removing…",
			confirm: "Confirm",
			disconnect: "Disconnect",
			connect: "Connect"
		},
		phone: {
			title: "Phone number",
			description: "Sign in with a code sent to your phone.",
			none: "No phone number added",
			noneDescription: "Add one to sign in with a code, or to use a passkey.",
			add: "Add a number",
			change: "Change",
			verifiedOn: "Verified on {{date}}",
			unverified: "Not verified yet",
			verifyTitle: "Add your phone number",
			verifyDescription: "We send a 6-digit code to confirm the number is yours.",
			numberLabel: "Phone number",
			sendCode: "Send code",
			sending: "Sending…",
			codeLabel: "Verification code",
			codeHint: "Sent to {{phone}}",
			verify: "Confirm number",
			verifying: "Confirming…",
			changed: "Phone number updated",
			errorTitle: "Couldn't update your number"
		},
		passkeys: {
			title: "Passkeys",
			description: "Sign in with Face ID, Touch ID or your device PIN instead of a code.",
			add: "Add a passkey",
			adding: "Waiting for your device…",
			addHint: "Add a phone number first — a passkey is bound to your number.",
			addPhone: "Add a number",
			none: "No passkeys yet",
			noneDescription: "Add one and your device signs you in — no codes to wait for.",
			unsupported: "This browser can't use passkeys. Open Maat on a device that can.",
			deviceLabelPlaceholder: "e.g. Sarah's MacBook",
			enrolledOn: "Added {{date}}",
			lastUsed: "Last used {{date}}",
			neverUsed: "Not used yet",
			revoke: "Stop accepting",
			revokeConfirm: "Maat will no longer accept this passkey. Continue?",
			revokeConfirmAction: "Stop accepting it",
			revoking: "Removing…",
			revokedNote: "Maat no longer accepts that passkey.",
			sendCodeTitle: "Confirm it is you",
			sendCodeDescription: "We send a code to {{phone}} before adding a passkey.",
			errorTitle: "Couldn't add a passkey",
			revokeErrorTitle: "Couldn't remove that passkey",
			deviceLabelLabel: "Name this device (optional)",
			descriptionNative: "Sign in with Face ID, Touch ID or your device passcode instead of a code.",
			unsupportedNative: "This device can't use passkeys. Open Maat on a device that can."
		}
	},
	help: {
		getHelp: {
			title: "Get help",
			description: "Find answers or reach out to our team.",
			helpCenter: "Help center",
			helpCenterDescription: "Browse guides and FAQs.",
			contactSupport: "Contact support",
			contactSupportDescription: "Open a support ticket."
		},
		legal: {
			title: "Legal",
			description: "Our terms and how we handle your data.",
			terms: "Terms of Service",
			termsDescription: "Read our terms.",
			privacy: "Privacy Policy",
			privacyDescription: "How we protect your data."
		},
		appVersion: { label: "App version" }
	},
	identity: {
		details: {
			title: "Your details",
			description: "Enter your legal name and date of birth exactly as they appear on your ID.",
			fullNameLabel: "Full legal name",
			fullNamePlaceholder: "e.g. Jane Adebayo Doe",
			fullNameRequired: "Enter your full legal name",
			dobLabel: "Date of birth",
			dobPlaceholder: "Select your date of birth",
			dobRequired: "Date of birth is required",
			submitting: "Submitting…",
			submit: "Submit for review",
			submitted: "Submitted for review",
			submitFailed: "Failed to submit verification"
		},
		didit: {
			title: "Verify your identity",
			description: "Have your passport or national ID ready. Our verification partner reads it and confirms it is yours — it usually takes about two minutes.",
			start: "Verify my identity",
			continue: "Continue verification",
			continueHint: "You already have a verification in progress — you can pick it up where you stopped.",
			retry: "Try again",
			checking: {
				title: "Checking your verification",
				body: "Hold on — the result comes back on its own."
			},
			unresolved: {
				title: "Still checking",
				body: "No result yet. An identity check can take a few minutes, and we update this as soon as it arrives. If you closed the check before finishing it, you can start it again.",
				action: "Check again",
				restart: "Start the check again",
				openInBrowser: "Open the check in your browser"
			},
			pending: {
				title: "Your verification is under review",
				description: "Someone is checking what you sent. There is nothing else for you to do — we update this as soon as there is a result."
			},
			readError: {
				title: "We couldn't load your verification status",
				body: "This is a connection problem, not a change to your account — nothing about your verification has been affected. Check your connection and try again.",
				action: "Try again"
			},
			unavailable: {
				title: "Automated verification is unavailable",
				body: "This is a temporary problem on our side, not a decision about your account. Try again in a few minutes, or verify manually instead."
			},
			failed: {
				title: "We couldn't start the check",
				body: "Something went wrong before the check could open. Please try again."
			},
			verified: {
				title: "Identity verified",
				description: "Your identity has been confirmed. Nothing further is needed.",
				badge: "Verified",
				on: "Verified {{date}}",
				issuedIn: "Document issued in {{country}}",
				nationality: "Nationality: {{country}}",
				documentsDisclosure: "Documents you uploaded"
			},
			rejected: { body: "Your last check did not pass. You can run it again, or verify manually instead." },
			manual: {
				title: "Verify manually instead",
				description: "Send your details and documents for our team to review. Use this if the automated check cannot read your document."
			},
			starting: "Preparing…",
			callback: {
				title: "Checking your verification",
				body: "We're waiting to hear the result of your identity check.",
				delayedTitle: "Still checking",
				delayedBody: "We haven't heard a result yet. An identity check can take a few minutes — your verification status updates on its own as soon as one arrives.",
				viewStatus: "View verification status"
			}
		},
		documents: {
			title: "Documents",
			description: "Upload clear photos or scans. Your documents are stored privately.",
			tapToCapture: "Tap to take a photo",
			uploading: "Uploading {{label}}…",
			uploaded: "{{label}} uploaded",
			uploadFailed: "Failed to upload {{label}}",
			removed: "{{label}} removed",
			removeFailed: "Failed to remove {{label}}",
			removalRequested: "Removal requested for {{label}}",
			removalRequestFailed: "Failed to request removal of {{label}}",
			removalCancelled: "Removal request for {{label}} cancelled",
			removalCancelFailed: "Failed to cancel removal of {{label}}",
			pendingRemoval: "Pending Removal",
			cancelRequest: "Cancel request",
			requestRemoval: "Request removal",
			remove: "Remove",
			fallbackFilename: "Document",
			rejected: "Rejected — {{reason}}",
			removalDeclined: "Removal declined — {{reason}}"
		},
		capture: {
			hintCard: "Fit your document inside the frame",
			hintSelfie: "Center your face in the oval",
			shutter: "Take photo",
			retake: "Retake",
			usePhoto: "Use photo",
			permissionTitle: "Camera access needed",
			permissionBody: "Maat needs your camera to capture identity documents. You can also use the system camera instead.",
			grantAccess: "Allow camera",
			systemCamera: "Use system camera"
		},
		status: {
			submittedAt: "Submitted {{date}}",
			reviewedAt: "Reviewed {{date}}"
		}
	},
	workspace: { create: {
		nameRequired: "Workspace name is required",
		typeRequired: "Select a workspace type",
		needHelp: "Need help?",
		unsavedConfirm: "You have unsaved changes. Are you sure you want to exit?",
		getStarted: "Get Started",
		creating: "Creating...",
		submit: "Create Workspace",
		typeTitle: "How would you like to host?",
		individual: "Individual",
		individualHint: "Host as a personal property owner",
		business: "Business",
		businessHint: "Host as a company or legal entity",
		nameTitle: "Give your workspace a name",
		nameLabel: "Workspace Name",
		namePlaceholder: "e.g. Sunset Stays, Beachfront Rentals...",
		nameHint: "This is how your workspace will appear to guests and team members.",
		confirmTitle: "You're all set!",
		confirmBodyIndividual: "Your workspace \"{{name}}\" is ready to be created as an individual workspace.",
		confirmBodyBusiness: "Your workspace \"{{name}}\" is ready to be created as a business workspace.",
		title: "Become a host",
		subtitle: "Create a workspace to start listing your places. You can manage the details from the web dashboard.",
		typeLabel: "Workspace type",
		individualDescription: "Host as yourself — ideal for a single owner.",
		businessDescription: "Host as a company or registered entity.",
		nameSectionLabel: "Workspace name",
		nativeNamePlaceholder: "e.g. Nile View Rentals",
		successToast: "You're all set up to host!",
		errorToast: "Could not set up hosting. Please try again."
	} },
	coupons: {
		widgetTitle: "Your coupons",
		percentOff: "{{percent}}% off",
		amountOff: "{{amount}} off",
		expiresOn: "Expires {{date}}",
		noExpiry: "No expiry",
		inviteReward: "Invite reward",
		empty: "No coupons yet. Codes you earn or receive will show up here.",
		loadFailed: "Could not load your coupons. Please try again."
	},
	creatorPartner: {
		intro: {
			title: "Become a Maat Creator Partner",
			body: "Share Maat with your audience through your own invite links and codes, and give your followers a discount on their first stay.",
			apply: "Apply now"
		},
		form: {
			title: "Creator Partner application",
			editTitle: "Edit application",
			displayNameLabel: "Display name",
			displayNamePlaceholder: "The name your audience knows you by",
			socialsTitle: "Where do you post?",
			socialsHint: "Add a link to at least one public profile.",
			channelPlaceholder: "https://…",
			noteLabel: "Anything else we should know?",
			notePlaceholder: "Tell us about your audience (optional)",
			submit: "Submit application",
			save: "Save changes",
			submitted: "Application submitted",
			updated: "Application updated",
			submitFailed: "Could not submit your application",
			validation: {
				displayNameRequired: "Display name is required",
				displayNameTooShort: "Use at least 2 characters",
				displayNameTooLong: "Keep the display name under 120 characters",
				atLeastOneChannel: "Add at least one social profile link",
				invalidUrl: "Enter a full URL, starting with https://",
				urlTooLong: "Keep the link under 500 characters",
				noteTooLong: "Keep the note under 1000 characters"
			}
		},
		pending: {
			title: "Application under review",
			body: "We're reviewing your application and will notify you once it's decided.",
			submittedOn: "Submitted {{date}}",
			withdraw: "Withdraw application",
			withdrawTitle: "Withdraw your application?",
			withdrawBody: "This removes your application from the review queue. You can reapply at any time.",
			withdrawn: "Application withdrawn",
			withdrawFailed: "Could not withdraw the application"
		},
		approved: {
			title: "You're a Maat Creator Partner!",
			body: "Congratulations — your application was approved. The Maat team will reach out about your invite links and codes.",
			badge: "Maat Creator Partner"
		},
		rejected: {
			title: "Your application wasn't approved",
			body: "You can update your details and reapply at any time.",
			reapply: "Update and reapply"
		},
		status: { pending: "Pending review" },
		cancel: "Cancel",
		edit: "Edit application"
	}
};
//#endregion
export { e as default };
